<template>
<v-app>
  <v-row>
    <v-col cols="24" lg="14" offset-lg="10">
      <div class="contact__content">
        <h1 class="has-text-color has-dark-color mt-0">Kontakt aufnehmen</h1>

        <contact-form
          :name="name"
          :authentication-token="authenticationToken"
          :required-fields="requiredFields">
            <contact-logged-in></contact-logged-in>
            <contact-fields :exclude="exclude"></contact-fields>
        </contact-form>
      </div>
    </v-col>
  </v-row>
</v-app>
</template>

<script>
import ContactForm from "./ContactForm";
import ContactFields from "./ContactFields";
import ContactLoggedIn from "../immoapp/contact/ContactLoggedIn";

export default {
  name: "ContactFormApp",

  components: {
    ContactForm,
    ContactFields,
    ContactLoggedIn
  },

  data() {
    return {
      name: "contact"
    }
  },

  computed: {
    requiredFields() {
      return this.$yeti.formRequiredFields(this.name);
    },

    authenticationToken() {
      if (this.$store && this.$store.state) {
        return this.$store.state.auth.authenticationToken;
      }

      return null;
    },

    loggedIn() {
      if (this.$store && this.$store.state) {
        return this.$store.state.user.loggedIn;
      }

      return false;
    },

    exclude() {
      let ignoreFields = [];
      if (this.loggedIn) {
        ignoreFields = ["email"];
      }

      let el = [];
      if (this.$root.exclude) {
        el = this.$root.exclude;
      }

      return ignoreFields.concat(el);
    }
  }
};
</script>
